import { render, staticRenderFns } from "./EmailVarification.vue?vue&type=template&id=6a988b54&"
import script from "./EmailVarification.vue?vue&type=script&lang=js&"
export * from "./EmailVarification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports